import React from "react";

const VimeoIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.9826 11.0266C39.7906 14.9319 37.0707 20.2675 31.8229 27.0495C26.3831 34.1369 21.7752 37.6726 18.0154 37.6726C15.6954 37.6726 13.7115 35.519 12.0956 31.1959L8.87969 19.3032C7.67973 14.9801 6.39977 12.8266 5.02382 12.8266C4.71983 12.8266 3.67987 13.4534 1.88793 14.723L0 12.2802C1.96793 10.5605 3.90386 8.82486 5.82379 7.07311C8.4637 4.79101 10.4316 3.58567 11.7436 3.47318C14.8475 3.16783 16.7674 5.28922 17.4874 9.85342C18.2554 14.7712 18.7993 17.8408 19.0873 19.0461C19.9833 23.1121 20.9753 25.1531 22.0472 25.1531C22.8792 25.1531 24.1431 23.8353 25.8071 21.1996C27.487 18.564 28.383 16.5551 28.495 15.173C28.735 12.8909 27.839 11.7498 25.8071 11.7498C24.8631 11.7498 23.8712 11.9587 22.8632 12.3766C24.8311 5.94813 28.591 2.83033 34.1428 3.00711C38.2706 3.13568 40.2066 5.80349 39.9826 11.0266Z",
  fill: "#1AB7EA"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(VimeoIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;